import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LibSharedModule } from '@lib-shared/lib-shared.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, LibSharedModule],
})
export class MaintenanceModule {}
